// ...existing code...
import React from "react";
import "./GlobalTechnologies.css";
import { FaGlobe, FaCloud, FaNetworkWired, FaRobot, FaShieldAlt, FaChartLine } from "react-icons/fa";
import { HiOutlineLightBulb } from "react-icons/hi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    icon: <FaCloud />,
    title: "Cloud Infrastructure & DevOps",
    text: "Deploy secure, scalable cloud systems with CI/CD automation, cost optimization, and monitoring.",
  },
  {
    icon: <FaRobot />,
    title: "AI & Automation",
    text: "Implement intelligent automation, predictive analytics, and conversational AI to boost efficiency.",
  },
  {
    icon: <FaNetworkWired />,
    title: "Enterprise Networking",
    text: "High-performance networks with zero-trust architecture and 24/7 monitoring for seamless connectivity.",
  },
  {
    icon: <FaChartLine />,
    title: "Data & Analytics",
    text: "Unlock business insights with real-time dashboards, data engineering, and AI-driven forecasting.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Cybersecurity & Compliance",
    text: "Protect critical assets with advanced threat detection, encryption, and governance frameworks.",
  },
  {
    icon: <HiOutlineLightBulb />,
    title: "Innovation Consulting",
    text: "Advisory on emerging tech adoption — from AI to blockchain — to accelerate digital transformation.",
  },
];

const WHY = [
  { icon: <FaChartLine />, title: "Result-driven strategy", text: "Technology aligned with measurable business goals." },
  { icon: <FaGlobe />, title: "Global delivery model", text: "Scalable services with 24/7 global support coverage." },
  { icon: <RiCustomerService2Fill />, title: "End-to-end partnership", text: "Consulting, implementation, and managed services." },
];

const GlobalTechnologies = () => {
  return (
    <div className="global-container">
      <header className="global-header">
        <div className="header-content">
          <h1>GLOBAL TECHNOLOGIES</h1>
          <p className="subtitle">
            Empowering enterprises with intelligent, scalable, and secure technology solutions to drive innovation and growth.
          </p>

          <div className="header-ctas">
             <Link
          to="/contact" // ✅ Navigate to Contact page
          className="btn-primary"
          aria-label="Contact Lyros"
        >
          Talk to our Expert team
        </Link>
          </div>
        </div>

        <svg className="header-decor" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="gB" x1="0" x2="1">
              <stop offset="0" stopColor="#0ea5e9" stopOpacity="0.14" />
              <stop offset="1" stopColor="#6366f1" stopOpacity="0.06" />
            </linearGradient>
          </defs>
          <path d="M0 140 C160 40 360 240 800 80 L800 200 L0 200 Z" fill="url(#gB)"></path>
        </svg>
      </header>

      <main className="lyros-main">
        <section className="intro-section card reveal-up">
          <div className="intro-grid">
            <div>
              <h2>Driving global innovation through technology</h2>
              <p>
                From infrastructure modernization to AI innovation, Global Technologies delivers future-ready solutions
                that empower enterprises to evolve, adapt, and scale efficiently.
              </p>
            </div>

            <div className="kpi-cards">
              <div className="kpi">
                <strong>40%</strong>
                <span>Cloud cost optimization</span>
              </div>
              <div className="kpi">
                <strong>3X</strong>
                <span>Faster innovation cycles</span>
              </div>
              <div className="kpi">
                <strong>99.9%</strong>
                <span>Uptime reliability</span>
              </div>
            </div>
          </div>
        </section>

        <section className="services-section">
          <h3 className="section-title">Our Services</h3>
          <div className="services-grid">
            {SERVICES.map((s, i) => (
              <article className="service-card reveal-up" key={i}>
                <div className="service-icon">{s.icon}</div>
                <div className="service-body">
                  <h4>{s.title}</h4>
                  <p>{s.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="examples-section">
          <h3 className="section-title">Case Studies</h3>
          <div className="examples-grid">
            <article className="example-card reveal-up">
              <h4>Global Cloud Migration</h4>
              <p>Seamlessly migrated legacy applications to cloud, cutting costs by 35% and improving scalability.</p>
            </article>
            <article className="example-card reveal-up">
              <h4>AI-Powered Operations</h4>
              <p>Developed predictive analytics solutions to improve maintenance planning and reduce downtime.</p>
            </article>
            <article className="example-card reveal-up">
              <h4>Enterprise Security Revamp</h4>
              <p>Implemented zero-trust architecture, reducing threat incidents and ensuring compliance readiness.</p>
            </article>
          </div>
        </section>

        <section className="why-section">
          <h3 className="section-title">Why choose us</h3>
          <div className="why-grid">
            {WHY.map((w, i) => (
              <div className="why-card reveal-up" key={i}>
                <div className="why-icon">{w.icon}</div>
                <div>
                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section reveal-up">
          <div className="cta-card">
            <div>
              <h3>Let’s build your digital future together</h3>
              <p>Partner with Global Technologies to accelerate innovation and scale your business securely.</p>
            </div>
            <div className="cta-actions">
             <Link
                       to="/contact" // ✅ Navigate to Contact page
                       className="btn-primary"
                       aria-label="Contact Lyros"
                     >
                      Get Started
                     </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default GlobalTechnologies;
